import Vue from 'vue'

const KyeTabPane = Vue.component('kye-tab-pane', {
  functional: true,
  render (h, self) {
    return h('el-tab-pane', self.data, self.children)
  }
})

export default KyeTabPane



// WEBPACK FOOTER //
// ./src/public/components/kye-tab-pane/index.js